module.exports = __webpack_public_path__ + "img/marker-nodisc-yellow.33a05f36.png";